/**
 * Pure H OS · Phase D · P0-4 · Briefs mock (types + live view).
 * Backed by MongoDB collection `pureh_briefs`.
 *
 * A "brief" is a period-scoped executive rollup — weekly/monthly/
 * quarterly — that references specific decisions (`decisionIds`) and
 * headline KPI moves for the period.
 */
import { liveArray } from "../services/store";

export type BriefKind = "weekly" | "monthly" | "quarterly";

export type BriefKpiHighlight = { label: string; value: string };

export type BoardBrief = {
  id: string;
  title: string;
  kind: BriefKind;
  period: string;              // "2026-W27" | "2026-02" | "2026-Q1"
  publishedRelative: string;
  authoredBy: string;
  headline: string;
  summary: string;
  kpiHighlights: BriefKpiHighlight[];
  decisionIds: string[];
  risksAcknowledged: number;
};

export const BRIEFS: BoardBrief[] = liveArray<BoardBrief>("briefs");
